module.exports = __webpack_public_path__ + "img/ce5a9cb.jpg";